import { render } from "./ProductDetailsPage.vue?vue&type=template&id=a5519340&scoped=true"
import script from "./ProductDetailsPage.vue?vue&type=script&lang=js"
export * from "./ProductDetailsPage.vue?vue&type=script&lang=js"

import "./ProductDetailsPage.vue?vue&type=style&index=0&id=a5519340&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a5519340"

export default script